import { gql } from '@apollo/client';

export const CREATE_ADDRESS = gql`
  mutation CREATE_ADDRESS($input: AddressInput!) {
    opsShippingAddress {
      address: create(input: $input)
    }
  }
`;
